export default __webpack_public_path__ + "static/media/treeIconType_color.75ac85ff.svg";